/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SendUserPrebidsAcceptedMail$Params {
  auctionId: number;
  sendExampleForUserId?: number;
  'X-API-Version'?: string;
}

export function sendUserPrebidsAcceptedMail(http: HttpClient, rootUrl: string, params: SendUserPrebidsAcceptedMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, sendUserPrebidsAcceptedMail.PATH, 'post');
  if (params) {
    rb.path('auctionId', params.auctionId, {});
    rb.query('sendExampleForUserId', params.sendExampleForUserId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

sendUserPrebidsAcceptedMail.PATH = '/api/auctions/{auctionId}/send-user-prebids-accepted';
